import { Link } from '@tanstack/react-router';
import type { LucideProps } from 'lucide-react';

import { Container } from '@/components/custom/container';
import type { AppRoutePath } from '@/routes/router';
import { useDashboardContext } from '@/stores/context/dashboard-layout-context';

type MenuProfileLinkProp = {
  primary: string;
  secondary: string;
  icon: React.ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
  >;
  path: AppRoutePath;
};

const MenuProfileLink = ({
  primary,
  secondary,
  icon: MenuProfileIcon,
  path,
}: MenuProfileLinkProp) => {
  const { toggleDropdown } = useDashboardContext();

  return (
    <Link
      to={path}
      className="flex cursor-pointer items-start gap-2 whitespace-nowrap hover:bg-gray-50"
      onClick={toggleDropdown}
    >
      <div className="item-center flex h-11 w-11 justify-center rounded-sm bg-blue-50 p-2">
        <MenuProfileIcon size={24} className="text-brand-blue" />
      </div>
      <Container direction="column" spacing={1}>
        <p className="text-sm leading-5">{primary}</p>
        <p className="text-xs leading-4 text-gray-500">{secondary}</p>
      </Container>
    </Link>
  );
};

export default MenuProfileLink;
